export const ALGO_TRADER_PLUS_BENEFITS = [
  "US Stocks, ETFs, Options, and Crypto",
  "9+ Years Historical Data",
  "Real-Time Market Coverage",
  "All US Stock Exchanges",
  "10,000 API Calls / Min",
  "Unlimited Symbols on WebSocket",
];

export const SUBSCRIBE_FORM_ID = "market-data-subscribe-form";
